import React, { useEffect, useState } from 'react'
import ProUpgradeModal from './ProUpgradeModal'
import type { ProSite } from '../../utils/proTrial'

// Mount 1 lần trong App. Bất kỳ đâu gọi openProTrial() → popup dùng thử/nâng cấp hiện TẠI CHỖ.
const GlobalProTrialModal: React.FC = () => {
  const [open, setOpen] = useState(false)
  const [site, setSite] = useState<ProSite>('ebook')

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent)?.detail || {}
      setSite(detail.site === 'eng' ? 'eng' : 'ebook')
      setOpen(true)
    }
    window.addEventListener('vatli365:open-pro-trial', handler as EventListener)
    return () => window.removeEventListener('vatli365:open-pro-trial', handler as EventListener)
  }, [])

  return <ProUpgradeModal isOpen={open} onClose={() => setOpen(false)} site={site} />
}

export default GlobalProTrialModal
